import { useEffect, useRef, useState } from 'react';
import { api } from '../lib/api';

export const ADSENSE_CLIENT = 'ca-pub-9166454411691375';

// Slots per defecte (unitats creades a la consola d'AdSense). Els valors
// configurats al panell d'administració tenen prioritat sobre aquests.
const DEFAULT_SLOTS = {
    home: '6511831742',   // unitat "display 1"
    watch: '8172292574',  // unitat "display 2"
};

// Memoria cau compartida perquè totes les unitats facin una única petició.
let slotsPromise = null;
function fetchAdSenseSlots() {
    if (!slotsPromise) {
        slotsPromise = api.get('/ads/platform-config', { params: { placement: 'banner' } })
            .then((response) => response.data?.adsense_slots || {})
            .catch(() => ({}));
    }
    return slotsPromise;
}

/**
 * Unitat nativa de Google AdSense. Només es renderitza si l'admin ha
 * configurat el data-ad-slot d'aquesta posició (home/watch) al panell.
 */
export function AdSenseUnit({ placement = 'home', className = '' }) {
    const [slot, setSlot] = useState(null);
    const pushed = useRef(false);
    const insRef = useRef(null);

    useEffect(() => {
        let cancelled = false;
        fetchAdSenseSlots().then((slots) => {
            const fromAdmin = String(slots?.[placement] || '').trim();
            const value = fromAdmin || DEFAULT_SLOTS[placement] || '';
            if (!cancelled && value) setSlot(value);
        });
        return () => { cancelled = true; };
    }, [placement]);

    useEffect(() => {
        if (!slot || pushed.current) return;
        pushed.current = true;
        try {
            (window.adsbygoogle = window.adsbygoogle || []).push({});
        } catch {}
    }, [slot]);

    if (!slot) return null;
    return (
        <div data-testid={`adsense-${placement}`} className={className}>
            <ins
                ref={insRef}
                className="adsbygoogle"
                style={{ display: 'block' }}
                data-ad-client={ADSENSE_CLIENT}
                data-ad-slot={slot}
                data-ad-format="auto"
                data-full-width-responsive="true"
            />
        </div>
    );
}
